<template>
  <section class="dashboard">
    <div class="page-header">
      <h3 class="page-title">
      <span class="page-title-icon bg-gradient-primary text-white mr-2">
        <i class="mdi mdi-chart-areaspline"></i>
      </span> Dashboard </h3>
      <nav aria-label="breadcrumb">
        <ul class="breadcrumb">
          <li class="breadcrumb-item active" aria-current="page">
            <span></span>Overview <i class="mdi mdi-alert-circle-outline icon-sm text-primary align-middle"></i>
          </li>
        </ul>
      </nav>
    </div>
    <div class="row">
      <div class="col-md-4 stretch-card grid-margin">
        <div class="card bg-gradient-danger card-img-holder text-white">
          <div class="card-body">
            <img src="@/assets/images/dashboard/circle.svg" class="card-img-absolute" alt="circle-image" />
            <h4 class="font-weight-normal mb-3">Usage <i class="mdi mdi-chart-line mdi-24px float-right"></i>
            </h4>
            <h2 class="mb-5" v-if="currentApiUsage && loadingToday === false">{{ currentApiUsage[0] }}</h2>
              <div class="dot-opacity-loader" v-show="loadingToday">
                <span></span>
                <span></span>
                <span></span>
              </div>
            <h6 class="card-text">Last 24 hours</h6>
          </div>
        </div>
      </div>
      <div class="col-md-4 stretch-card grid-margin">
        <div class="card bg-gradient-info card-img-holder text-white">
          <div class="card-body">
            <img src="@/assets/images/dashboard/circle.svg" class="card-img-absolute" alt="circle-image" />
            <h4 class="font-weight-normal mb-3">Account Status <i class="mdi mdi-bookmark-outline mdi-24px float-right"></i>
            </h4>
            <h2 class="mb-5" v-if="usagePlan && loadingType === false">{{ usagePlan }}</h2>
              <div class="dot-opacity-loader" v-show="loadingType">
                <span></span>
                <span></span>
                <span></span>
              </div>
            <router-link to="/upgrade" class="text-white"><h6 class="card-text" v-if="usagePlan == 'FREEBIE'">Support tcup by upgrading</h6></router-link>
            <h6 class="card-text" v-if="usagePlan == 'BESTIE'">Thank you for your support</h6>
          </div>
        </div>
      </div>
      <div class="col-md-4 stretch-card grid-margin">
        <div class="card bg-gradient-success card-img-holder text-white">
          <div class="card-body">
            <img src="@/assets/images/dashboard/circle.svg" class="card-img-absolute" alt="circle-image" />
            <h4 class="font-weight-normal mb-3">Registered Account<i class="mdi mdi-diamond mdi-24px float-right"></i>
            </h4>
            <h2 class="mb-5" v-if="user">{{ user.attributes.email | splitEmail }}</h2>
            <h2 class="mb-5" v-else>Not found</h2>
            <div class="dot-opacity-loader" v-show="loadingUser">
              <span></span>
              <span></span>
              <span></span>
            </div>
            <h6 class="card-text" v-if="user">{{ user.attributes.email }}</h6>
            <h6 class="card-text" v-else>notfound@missing</h6>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12 grid-margin">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title">API Keys</h4>
            <div class="table-responsive">
              <table class="table">
                <thead>
                  <tr>
                    <th> Key </th>
                    <th> Type </th>
                    <th> Status </th>
                    <th> Copy </th>
                    <th> New </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td v-if="currentKey">{{ currentKey.apikey }}</td>
                    <td v-else>No Key</td>
                    <td class="dot-opacity-loader" v-show="loadingKey">
                      <span></span>
                      <span></span>
                      <span></span>
                    </td>
                    <td v-if="usagePlan">{{ usagePlan }} plan</td>
                    <td v-else>Unknown plan</td>
                    <td>
                      <label class="badge badge-gradient-success">ACTIVE</label>
                    </td>
                    <td> <b-button variant="info" class="btn btn-sm btn-icon-text" v-on:click="copy(currentKey.apikey)"><i class="mdi mdi-content-copy"></i> Copy </b-button> </td>
                    <td> <b-button variant="danger" class="btn btn-sm btn-icon-text" v-on:click="requestKey"><i class="mdi mdi-folder-plus"></i> New </b-button> </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { Auth } from 'aws-amplify'

function getUser() {
  return Auth.currentAuthenticatedUser().then((data) => {
  if (data && data.signInUserSession) {
    return data;
  } 
  }).catch((e) => {
    //console.log(e)
    return null
  });
}

export default {
  name: 'dashboard',
  components: {
  },
  data() {
    return {
      loadingToday: true,
      loadingType: true,
      loadingUser: true,
      loadingKey: true,
      user: null,
      keyusage: null,
      currentKey: null,
      onCreated: null,
      currentApiUsage: null,
      submitStatusRK: null,
      submitStatusGA: null,
      submitStatusCU: null,
      usagePlan: null,
      canCopy: false,
    };
  },
  methods: {
    async requestKey() {
      this.user = await getUser();
      this.currentKey.apikey = null;
      this.loadingKey = true;

      // POST request using fetch with error handling
      const requestOptions = {
        method: 'GET',
        headers: { 'Content-Type': 'application/json', 'Authorization': this.user.signInUserSession.accessToken.jwtToken }
      };
      fetch(process.env.VUE_APP_BASE_URL + '/requestkey', requestOptions)
        .then(async response => {
          const data = await response.json();

          // check for error response
          if (!response.ok) {
            // get error message from body or default to response status
            const error = (data && data.message) || response.status;
            this.currentKey = 'Error setting key'
            this.loadingKey = false;
            return Promise.reject(error);
          }

          this.currentKey = data;
          this.loadingKey = false;
        })
        .catch(error => {
          this.currentKey = 'Error setting key'
          //console.error('There was an error!', error);
        });
    },
    async getApiKey() {
      this.user = await getUser();
  
      // POST request using fetch with error handling
      const requestOptions = {
        method: 'GET',
        headers: { 'Content-Type': 'application/json', 'Authorization': this.user.signInUserSession.accessToken.jwtToken }
        //body: JSON.stringify({ user: this.user.attributes.email })
      };
      fetch(process.env.VUE_APP_BASE_URL + '/apikey', requestOptions)
        .then(async response => {
          const data = await response.json();

          // check for error response
          if (!response.ok) {
            // get error message from body or default to response status
            const error = (data && data.message) || response.status;
            this.currentKey.apikey = 'Error getting key'
            this.loadingKey = false;
            return Promise.reject(error);
          }

          if (data.apikey == false) {
            this.currentKey.apikey = 'No key'
            this.loadingKey = false;
          } else {
            this.currentKey = data;
            this.loadingKey = false;
            //this.submitStatusGA = 'OK'
          }
          
        })
        .catch(error => {
          this.currentKey.apikey = 'Error getting key'
        });
    },
    async checkUsage() {
      this.user = await getUser();
      // POST request using fetch with error handling
      const requestOptions = {
        method: 'GET',
        headers: { 'Content-Type': 'application/json', 'Authorization': this.user.signInUserSession.accessToken.jwtToken }
        //body: JSON.stringify({ user: this.user.attributes.email })
      };
      fetch(process.env.VUE_APP_BASE_URL + '/keyusage', requestOptions)
        .then(async response => {
          const data = await response.json();

          // check for error response
          if (!response.ok) {
            // get error message from body or default to response status
            const error = (data && data.message) || response.status;
            // this.submitStatusCU = 'ERROR'
            this.currentApiUsage = [0, 0]
            this.loadingToday = false;
            return Promise.reject(error);
          }

          if (data.message) {
            //this.submitStatusCU = 'INFO'
            this.currentApiUsage = [0, 0]
            this.loadingToday = false;
          } else if (data == 'error') {
            this.currentApiUsage = [0, 0]
            this.loadingToday = false;
          }
          else {

            //this.keyusage = data;
            let topKey;
            for (var key in data) {
              topKey = key;
              //console.log("key " + key + " has value " + data[key]);
            }

            this.keyusage = data[topKey];
            this.currentApiUsage = data[topKey][data[topKey].length -1]
            this.loadingToday = false;
            //this.submitStatusCU = 'OK'
          }
        })
        .catch(error => {
          //this.errorMessage = error;
          this.currentApiUsage = [0, 0]
          this.loadingToday = false;
          //this.submitStatusCU = 'ERROR'
          //console.error('There was an error!', error);
        });
    },
    async copy(s) {
      await navigator.clipboard.writeText(s);      
    },
    async checkUsagePlan() {
      this.user = await getUser();

      const requestOptions = {
        method: 'GET',
        headers: { 'Content-Type': 'application/json', 'Authorization': this.user.signInUserSession.accessToken.jwtToken }
      };
      fetch(process.env.VUE_APP_BASE_URL + '/usageplan', requestOptions)
        .then(async response => {
          const data = await response.json();

          // check for error response
          if (!response.ok) {
            // get error message from body or default to response status
            const error = (data && data.message) || response.status;
            //this.submitStatusGA = 'ERROR'
            this.usagePlan = 'Error';
            this.loadingType = false;
            return Promise.reject(error);
          }

          if (data.apiplan == "" || data.apiplan == process.env.VUE_APP_FREEID) {
            this.usagePlan = 'FREEBIE'
            this.loadingType = false;
          } else {
            this.usagePlan = 'BESTIE'
            this.loadingType = false;
          }
          
        })
        .catch(error => {
          this.usagePlan = 'Error';
          this.loadingType = false;
        });
    },
  },
  mounted() {
    this.keyusage = this.checkUsage();
    this.currentKey = this.getApiKey();
    this.canCopy = !!navigator.clipboard;
  },
  filters: {
    splitEmail: function(email) {
      let split = email.split('@')
          split = split[0]
      return split
    },
  },
  async beforeCreate() {    
    let user = await getUser();
    this.user = user;
    this.loadingUser = false;
    let plan = await this.checkUsagePlan();
    this.usagePlan = plan;
  }
}
</script>

<style scoped>

</style>